<template>
  <VeeForm ref="form" class="row" :id="fieldId" :style="styles" :initial-values="generateInitialValues(fields)">
    <template v-for="field in fields" :key="field.id">
      <componentRenderer
        :class="`col-lg-${field.properties.grid.columns}`"
        :field="field"
        v-on:component-updated="updated"
      />
    </template>
  </VeeForm>
</template>
<script>
import componentRenderer from "@/components/component-renderer";
import { mapGetters } from "vuex";
import { Form as VeeForm } from "vee-validate";

export default {
  name: "form-component",
  components: { componentRenderer, VeeForm },
  props: {
    fieldId: String,
    requires: Array,
    successAction: {
      type: Object,
      default: () => null
    },
    apiUrl: {
      type: String,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    styles: {
      type: Object,
      required: false,
      default: () => {
      }
    },
    keepInState: Array
  },
  computed: {
    ...mapGetters(["customerToken", "campaignId", "receiptToken", "getErrorImageList"])
  },
  methods: {
    clicked () {
      // console.log("FORM CLICKED", this);
    },
    generateInitialValues(fields) {
      const values = {};
      fields.forEach(field => {
        const name = field.properties.name;
        const value =
          field.fieldType === 'text-input' ? field.properties.text :
          field.fieldType === 'select-input' ? field.properties.text :
          field.fieldType === 'radio-input' ? field.properties.selectedValue :
          field.fieldType === 'checkbox' ? field.properties.checked :
          field.fieldType === 'date-input' ? field.properties.value :
          null;

        if (name && value !== null) {
          values[name] = value;
        }

        if (field.properties.fields) {
          Object.assign(values, this.generateInitialValues(field.properties.fields));
        }
      });
      return values;
    },
    clear () {
      this.fields.forEach(field => {
        if (field.fieldType === "text-input") {
          field.properties.text = "";
        } else if (field.fieldType === "select-input") {
          field.properties.text = "";
        } else if (field.fieldType === "radio-input") {
          field.properties.selectedValue = "";
        } else if (field.fieldType === "checkbox") {
          field.properties.checked = "";
        } else if (field.fieldType === "date-input") {
          field.properties.value = "";
        }
      });
    },
    getFieldData (fields, formData) {
      fields.forEach(field => {
        if (field.fieldType === "text-input") {
          const name = field.properties.name;
          const apiName = field.properties.apiName || name;
          const value = field.properties.text;
          formData[apiName] = name === "iban" || apiName === "iban" ? value.replace(/\s/g, '') : value;
        } else if (field.fieldType === "select-input") {
          const name = field.properties.name;
          const apiName = field.properties.apiName || name;
          const value = field.properties.text;
          formData[apiName] = value;
        } else if (field.fieldType === "radio-input") {
          const name = field.properties.name;
          const apiName = field.properties.apiName || name;
          const value = field.properties.selectedValue;
          formData[apiName] = value;
        } else if (field.fieldType === "checkbox") {
          const name = field.properties.name;
          const apiName = field.properties.apiName || name;
          const value = field.properties.checked;
          formData[apiName] = value;
        } else if (field.fieldType === "date-input") {
          const name = field.properties.name;
          const apiName = field.properties.apiName || name;
          const value = field.properties.value;
          formData[apiName] = value;
        } else if (field.properties.fields) {
          this.getFieldData(field.properties.fields, formData);
        }
      });
    },
    getFormData (formId, triggers) {
      if (this.fieldId === formId) {

        let formData = {};
        if (Object.keys(this.$route.query).length > 0) {
          formData = { ...this.$route.query }
        }
        const apiUrl = this.apiUrl;
        if (this.locale) {
          formData.lang = this.locale;
        }
        formData.customerToken = this.customerToken;
        formData.campaignId = this.campaignId;
        formData.receiptToken = this.receiptToken;
        this.getFieldData(this.fields, formData)

        this.$refs.form.validate().then(isValid => {
          if (isValid.valid) {
            const presistentFormFields = {}
            if (this.keepInState) {
              this.keepInState.forEach(field => {
                presistentFormFields[field] = this.$store.state.formData[field]
              })
            }
            this.$store.commit("setField", {
              field: "formData",
              value: { ...presistentFormFields, ...formData }
            });
            this.$store
              .dispatch("sendFormData", { formData, apiUrl, triggers })
              .then(r => {
                if (r.consumerId !== undefined) {
                  this.$store.commit("setconsumerId", r.consumerId);
                }
                if (r.response && this.successAction) {
                  const fn = this.successAction.fn;
                  const params = this.successAction.params;
                  this[fn](params, this);
                  this.$eventHub.emit("done-event-trigger", {
                    parent: this,
                    status: true
                  });
                }
                this.$eventHub.emit("done-event-trigger", {
                  parent: this,
                  status: false,
                  message: r.message || "Unexpected Error",
                  invalid_fields: r.invalid_fields || []
                });

                if (r.response) {
                  // append response payload into formData
                  this.$store.commit("setField", {
                    field: "formData",
                    value: {
                      ...presistentFormFields,
                      ...formData,
                      ...r
                    }
                  });
                }
                if(r.referenceNumber !== undefined) {
                  this.$store.commit("setReferenceNumber", r.referenceNumber)
                }
              })
              .catch(e => {
                this.$eventHub.emit("done-event-trigger", {
                  parent: this,
                  status: false
                });
              });
          } else {
            // this.scrollTo(`[id=${this.fieldId}`);
            // document.getElementById(this.fieldId).scrollIntoView();
            this.$eventHub.emit("done-event-trigger", {
              parent: this,
              status: false
            });
          }
        });


        return formData
      }
    },
    updated (field, properties) {
      if (!field || !field.fieldId) {
        return;
      }

      let updatedField = _(this.fields).find(function (fld) {
        return fld.fieldId === field.fieldId;
      });

      if (updatedField) {
        updatedField.properties = { ...updatedField.properties, ...properties };

        if (this.fieldId) {
          this.$store.dispatch("setComponentStatus", {
            component: this.fieldId,
            status: true
          });
        }
      }
    },
  },
  mounted () {
    this.$eventHub.on("getFormData-event", this.getFormData);
  },
  beforeUnmount () {
    this.$eventHub.off("getFormData-event", this.getFormData);
  }
};
</script>
<style lang="scss" scoped>
  .row {
    :deep([disabled="true"]) {
      pointer-events: none;
    }
  }
</style>
